import clsx from 'clsx';
import { FocusEvent, useCallback } from 'react';

import styles from './FormElement.module.css';

type FormElementTextProps = {
  label?: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  helpText?: string;
};

export const FormElementText = ({ value, onChange, label, placeholder, helpText }: FormElementTextProps) => {
  const handleChange = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <label className="block text-left font-sans">
      {Boolean(label) && <span className="text-darkgray text-sm">{label}</span>}
      <input
        className={clsx(
          styles.interactiveBorderEdit,
          'appearance-none bg-white border border-solid border-gray rounded outline-none py-2 px-2 text-sm w-full block font-sans',
        )}
        placeholder={placeholder}
        defaultValue={value}
        onBlur={handleChange}
      />
      {Boolean(helpText) && <span className="text-darkgray font-italic text-sm leading-none">{helpText}</span>}
    </label>
  );
};
